import { Link, useRouteError } from 'react-router-dom';

import { Container } from '@sshop/ui';

export function RootErrorBoundary() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : 'Unexpected error';

  return (
    <Container size="md" className="py-20">
      <h1 className="text-3xl font-semibold">Something went wrong</h1>
      <p className="mt-2 text-fg-secondary">{message}</p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-md bg-accent px-4 py-2 text-accent-fg hover:bg-accent-hover"
      >
        Back to home
      </Link>
    </Container>
  );
}
